import Service from './Service'
import { LOT, WISHLIST } from './apiUrls'

export default class LotService extends Service {
  getExport (query) {
    return this.axios.get('lots-export', {params: query}, {responseType: 'arraybuffer'})
  }
  patchAll (query, data) {
    return this.axios.patch(`${LOT}`, data, {params: query})
  }
  getOptions (id, query) {
    return this.axios.get(`${LOT}/${id}/options`, {params: query})
  }
  getExternal (id) {
    return this.axios.get(`${LOT}/${id}/external-sale`)
  }
  postExternal (id, data) {
    return this.axios.post(`${LOT}/${id}/external-sale`, data)
  }
  deleteExternal (id) {
    return this.axios.delete(`${LOT}/${id}/external-sale`)
  }
  getWishlist () {
    return this.axios.get(`${WISHLIST}`)
  }
  postWishlist (data) {
    return this.axios.post(`${WISHLIST}`, data)
  }
  deleteWishlist (id) {
    return this.axios.delete(`${WISHLIST}/${id}`)
  }
}



// WEBPACK FOOTER //
// ./src/services/api/LotService.js